<template>
  <div class="order-report-container">
    <!-- 顶部导航栏 -->
    <van-nav-bar
      title="在线报备"
      fixed
      placeholder
      v-if="!isNativeApp"
    />

    <div class="order-report-content">

      <!-- 订单信息和申请类型卡片 -->
      <div class="order-info-application-card">
        <!-- 订单信息展示 -->
        <div class="order-info-section">
          <div class="car-info-item">
            <span>订单号</span>
            <span
              class="car-no"
            >{{ taskDetail.orderNo || "-" }}</span>
          </div>
          <div class="car-info-item">
            <span>车牌号</span>
            <span
              class="car-no"
            >{{ taskDetail.carNo || "-" }}</span>
          </div>
          <div class="car-info-item">
            <span>产品类型</span>
            <span
              class="car-no"
            >{{ taskDetail.productCategoryName || "-" }}</span>
          </div>
          <div class="car-info-item">
            <span>优惠信息</span>
            <span
              class="car-no"
            >{{ rightRemark || "-" }}</span>
          </div>
        </div>

        <!-- 申请类型选项 -->
        <div class="application-type-section">
          <div class="section-header">
            <span class="header-title">请选择申请类型</span>
          </div>
          <div class="application-grid">
            <div
              v-for="item in applicationTypes"
              :key="item.value"
              class="application-item"
              @click="selectApplicationType(item)"
            >
              <div class="icon-wrapper">
                <img
                  :src="getApplicationIcon(item.key)"
                  alt=""
                  srcset=""
                >
                <span class="item-text">{{ item.value }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 历史工单记录 -->
      <div
        class="history-records-section"
        v-if="historyRecords.length > 0"
      >
        <div class="records-header">
          已提交工单
        </div>
        <div class="order-info-application-card">
          <div class="history-records-list">
            <div
              v-for="(record, index) in historyRecords"
              :key="index"
              class="record-item"
              @click="viewWorkOrderDetail(record)"
            >
              <div class="record-content">
                <div class="record-title">{{ record.appTypeDesc }}</div>
                <div :class="['record-status', getStatusClass(record.status)]">{{ record.statusDesc }}</div>
              </div>
              <div class="record-time">
                <span>{{ record.createdTime }}</span>
                <van-icon
                  name="arrow"
                  size="16"
                  class="arrow-icon"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  workOrderList
} from '@/common/apiReport.js';
import {
  getTaskDetail,
  getRightRemark
} from '@/common/apiPaic.js';
import { queryDictByCodes } from '@/common/api.js';
import Util from '@/common/util.js';

export default {
  name: 'OrderReportBase',
  data() {
    return {
      taskDetail: {},
      rightRemark: '',
      // 申请类型选项
      applicationTypes: [],
      // 历史工单记录
      historyRecords: []
    };
  },
  computed: {
    isNativeApp() {
      return this.$route.name === 'OrderReportAppBase';
    }
  },
  created() {
    const { orderNo, taskNo } = this.$route.params;
    if (orderNo && taskNo) {
      this.orderNo = orderNo;
      this.taskNo = taskNo;
    }
    this.init();
  },
  mounted() {
    Util.initHistoryFix();
  },
  methods: {
    init() {
      this.queryDictByCodes();
      this.getTaskDetail();
      this.getRightRemark();
      this.loadHistoryRecords();
    },
    async queryDictByCodes() {
      try {
        const res = await queryDictByCodes({
          codes: [
            'WORK_ORDER_APP_TYPE' // APP工单申请类型
          ]
        });
        if (res && res.length > 0) {
          this.applicationTypes = res.find(
            (item) => item.code === 'WORK_ORDER_APP_TYPE'
          ).kvs;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getTaskDetail(noLoading) {
      if (!(this.orderNo && this.taskNo)) {
        return;
      }
      if (!noLoading) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
      }
      try {
        const data = await getTaskDetail({
          orderNo: this.orderNo,
          taskNo: this.taskNo
        });
        if (data) {
          this.taskDetail = data;
        }
        if (!noLoading) {
          this.$toast.clear();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getRightRemark() {
      if (!(this.orderNo && this.taskNo)) {
        return;
      }
      try {
        const data = await getRightRemark({
          orderNo: this.orderNo
        });
        this.rightRemark = data.resultValue;
      } catch (error) {
        console.log(error);
      }
    },
    // 加载历史工单记录
    async loadHistoryRecords() {
      try {
        const data = await workOrderList({
          orderNo: this.orderNo
        });
        this.historyRecords = data || [];
      } catch (error) {
        console.log(error);
      } finally {
        this.$toast.clear();
        this.isSubmitting = false;
      }
    },
    // 选择申请类型
    selectApplicationType(item) {
      // 跳转到对应的二级页面
      this.$router.push({
        name: this.isNativeApp ? 'OrderReportAppCreate' : 'OrderReportCreate',
        params: {
          orderNo: this.orderNo,
          taskNo: this.taskNo
        },
        query: {
          type: item.key,
          typeName: item.value
        }
      });
    },
    // 查看工单详情
    viewWorkOrderDetail(record) {
      // 可以跳转到工单详情页或弹窗展示详情
      this.$toast('工单ID: ' + record.workOrderId);
      // 跳转到对应的二级页面
      this.$router.push({
        name: this.isNativeApp ? 'OrderReportAppDetail' : 'OrderReportDetail',
        params: {
          orderNo: this.orderNo,
          taskNo: this.taskNo
        },
        query: {
          workOrderId: record.workOrderId
        }
      });
    },
    // 图片预览变化
    onImagePreviewChange(index) {
      this.activePreviewIndex = index;
    },
    // 获取申请类型对应的图标
    getApplicationIcon(type = 'OTHER_ISSUE') {
      try {
        return require('@/assets/img/orderReport/icon-' + type + '.png');
      } catch (error) {
        return require('@/assets/img/orderReport/icon-OTHER_ISSUE.png');
      }
    },
    // 获取状态类名
    getStatusClass(status) {
      const classMap = {
        'processing': 'status-processing',
        'pending': 'status-pending',
        'finished': 'status-finished',
        'closed': 'status-closed'
      };
      return classMap[status] || 'status-default';
    }
  }
};
</script>

<style lang="scss" scoped>
.order-report-container {
  min-height: 100vh;
  background-color: #f5f5f5;
  .order-report-content {
    padding: 12px;
  }
}

.order-info-application-card {
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  padding: 16px;
}

.section-header {
  display: flex;
  align-items: center;

  .header-title {
    font-size: 15px;
    color: #383838;
    letter-spacing: -0.38px;
    text-align: justify;
    font-weight: 500;
  }
}

.order-info-section,
.application-type-section {
  &:first-child {
    margin-top: 0;
  }
}

.order-info-section {
  padding-bottom: 8px;

  .car-info-item {
    display: flex;
    font-size: 15px;
    color: #999999;
    letter-spacing: -0.38px;
    text-align: justify;
    font-weight: 400;
    line-height: 21px;

    & + .car-info-item {
      padding-top: 12px;
    }
    span {
      &:first-child {
        flex: 0 0 74px;
      }
      & + span {
        color: #383838;
      }
    }
  }
}

.application-type-section {
  padding-top: 8px;
}

.application-grid {
  display: flex;
  flex-wrap: wrap;

  .application-item {
    display: flex;
    align-items: center;
    width: calc(50% - 32px - 6px);
    margin-top: 12px;
    padding: 6px 16px;
    border-radius: 8px;
    background: #F5F6F7;
    cursor: pointer;

    &:nth-child(odd) {
      margin-right: 12px;
    }

    &:last-child {
      margin-right: 0;
      width: calc(100% - 32px);
    }

    .icon-wrapper {
      display: flex;
      align-items: center;
      img {
        width: 24px;
        height: 24px;
        margin-right: 4px;
      }
      .item-text {
        font-size: 15px;
        color: #646464;
        letter-spacing: -0.38px;
        text-align: justify;
        font-weight: 400;
      }
    }
  }
}

.history-records-section {
  margin-top: 24px;
  .order-info-application-card {
    padding: 0 16px;
  }
  .records-header {
    font-size: 15px;
    color: #999999;
    letter-spacing: -0.38px;
    text-align: justify;
    font-weight: 400;
    margin-bottom: 8px;
  }

  .history-records-list {
    .record-item {
      display: flex;
      flex-direction: column;
      padding: 16px 0;
      border-bottom: 1px solid #e6e6e6;
      cursor: pointer;

      &:last-child {
        border-bottom: none;
      }

      .record-content {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .record-title {
          font-size: 15px;
          color: #383838;
          letter-spacing: -0.38px;
          text-align: justify;
          font-weight: 500;
        }

        .record-status {
          font-size: 15px;
          letter-spacing: -0.38px;
          text-align: justify;
          font-weight: 400;
        }

        .status-processing {
          color: #5EC360;
        }
        .status-pending {
          color: #FF8A59;
        }

        .status-completed,
        .status-closed,
        .status-default {
          color: #9e9e9e;
        }
      }

      .record-time {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 8px;

        span {
          font-size: 15px;
          color: #999999;
          letter-spacing: -0.38px;
          text-align: justify;
          font-weight: 400;
        }

        .arrow-icon {
          color: #ccc;
        }
      }
    }
  }
}
</style>
